import { EntityAudit } from "@modernary/mui/components/audit";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocuments,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { RouterView, type RouterOptions } from "vue-router";
import { vacantLandEnforcementActionRouteName } from "../enforcementAction/enforcementAction";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  vacantLandEnforcementActions: "VacantLandEnforcementAction.VacantLandEnforcementActions",
  list: "VacantLandEnforcementAction.VacantLandEnforcementActionsList",
  // new: "VacantLandEnforcementAction.VacantLandEnforcementActionNew",
  base: "VacantLandEnforcementAction.VacantLandEnforcementActionBase",
  view: "VacantLandEnforcementAction.VacantLandEnforcementActionView",
  edit: "VacantLandEnforcementAction.VacantLandEnforcementActionEdit",
  documents: "VacantLandEnforcementAction.VacantLandEnforcementActionDocuments",
  documentsEdit: "VacantLandEnforcementAction.VacantLandEnforcementActionDocumentsEdit",
  documentsNew: "VacantLandEnforcementAction.VacantLandEnforcementActionDocumentsNew",
  audit: "VacantLandEnforcementAction.VacantLandEnforcementActionAudit",
};

export { names as vacantLandEnforcementActionRouteNames };

const vacantLandEnforcementActionRoutes: RouterOptions["routes"] = [
  {
    path: "/vacantLandEnforcementAction",
    name: names.vacantLandEnforcementActions,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Vacant Land Enforcement Actions",
          lookupGroups: ["DeliveryMethod", "EnforcementActionType", "InspectionCategory"],
        },
        component: () => import("@/views/vacantLandEnforcementActions/VacantLandEnforcementActionsList.vue"),
      },
      // {
      //   path: "new/:inspectionId(\\d+)?",
      //   component: () => import("@/views/vacantLandEnforcementActions/VacantLandEnforcementActionBase.vue"),
      //   redirect: { name: names.new },
      //   props: true,
      //   children: [
      //     {
      //       path: "",
      //       name: names.new,
      //       meta: { title: "New Enforcement Action", isNew: true },
      //       component: () => import("@/views/vacantLandEnforcementActions/VacantLandEnforcementActionEdit.vue"),
      //     },
      //   ],
      // },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/vacantLandEnforcementActions/VacantLandEnforcementActionBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Vacant Land Enforcement Action View" },
            component: () => import("@/views/enforcementAction/EnforcementActionView.vue"),
            props: { entityRouteName: vacantLandEnforcementActionRouteName },
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Vacant Land Enforcement Action Edit", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionEdit.vue"),
            props: { entityRouteName: vacantLandEnforcementActionRouteName },
          },

          {
            path: "documents",
            name: names.documents,
            meta: { title: "Vacant Land Enforcement Action Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="vacantLandEnforcementAction" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Vacant Land Enforcement Action Document", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionDocument.vue"),
            props: { resourceTypeKey: "vacantLandEnforcementAction" },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Vacant Land Enforcement Action Documents", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionDocuments.vue"),
            props: { resourceTypeKey: "vacantLandEnforcementAction" },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Vacant Land Enforcement Action Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="EnforcementAction" />,
            },
          },
        ],
      },
    ],
  },
];
export default vacantLandEnforcementActionRoutes;
